module.exports = __webpack_public_path__ + "static/background-9a6b7b7489e81e9921c42becdc0ac0a5.jpg";